import { defineMessages } from 'react-intl';

const loyaltyMessages = defineMessages({
    loyaltyLabel: {
        id: 'loyalty.loyaltyMessages.loyaltyLabel',
        description: 'Label for the Loyalty Number field',
        defaultMessage: 'Rewards Program Number (optional)'
    },
    logoAlt: {
        id: 'loyalty.loyaltyMessage.logoAlt',
        description: 'Alt text for the lotalty logo',
        defaultMessage: 'Rewards Program'
    },
    invalidLoyaltyNumber: {
        id: 'loyalty.loyaltyMessages.invalidLoyaltyNumber',
        description: 'Error message for the Loyalty Number field',
        defaultMessage: 'Please enter a valid rewards program number'
    }
});

export default loyaltyMessages;
